import { RefObject } from 'react';

const focusOnElement = (ref: RefObject<HTMLElement | null>): void => {
  setTimeout(() => {
    ref.current?.focus();
  }, 0);
};

export default focusOnElement;
